/**
 * Document viewer — honest "preview coming soon" state (real in-app file
 * rendering lands with document storage; see DEFERRED list in
 * docs/audit/00-MASTER.md). Previously showed a permanent fake
 * text-skeleton with a fabricated "Page 1 of 3" caption (F4 P0-3) — that
 * read as a hung/broken screen and implied a real document was loaded when
 * nothing had been fetched. Port of screens-account.jsx DocViewer.
 */
import { useLocalSearchParams } from 'expo-router';
import React from 'react';
import { View } from 'react-native';

import { space } from '@bero/tokens';
import { InfoNote } from '@/components/gate/bits';
import { goBack } from '@/features/account-admin/bits';
import { Icon } from '@/features/account-admin/icons';
import { useT } from '@/i18n';
import { useTheme } from '@/theme';
import { AppText, EmptyState, IconButton, Screen, TopBar } from '@/ui';

export default function DocViewerScreen() {
  const { colors } = useTheme();
  const { t } = useT();
  const { name } = useLocalSearchParams<{ name?: string }>();
  const [notice, setNotice] = React.useState<string | null>(null);

  return (
    <Screen scroll={false}>
      <TopBar
        title={t('dv_title')}
        onBack={goBack}
        right={
          <IconButton label={t('dv_download')} onPress={() => setNotice(t('dv_download_unavailable'))}>
            <Icon name="download" size={20} color={colors.textPrimary} />
          </IconButton>
        }
      />
      <Screen padded style={{ paddingTop: space.s4 }}>
        <AppText variant="headingSm" weight="500" style={{ marginBottom: space.s3 }}>
          {typeof name === 'string' && name.length > 0 ? name : t('dv_title')}
        </AppText>
        {notice ? <InfoNote icon="info" style={{ marginBottom: space.s3 }}>{notice}</InfoNote> : null}
        <View style={{ marginTop: space.s6 }}>
          <EmptyState
            icon={<Icon name="file-text" size={40} color={colors.textTertiary} />}
            title={t('dv_preview_soon')}
            body={t('dv_preview_soon_body')}
          />
        </View>
      </Screen>
    </Screen>
  );
}
